// All of the content for the app is stored here, so we can make global
// changes and not mess up the tests

export const getWebsiteUrl = () => {
  return "https://www.laketrust.org";
};

export const getWebsiteDocumentUrl = () => {
  return "https://apps.laketrust.org";
};

export const getEnrollmentUrl = () => {
  const enrollPath = "/online-banking/#/enroll-user";

  if (typeof window !== "undefined") {
    const origin = window.location.origin;
    const appsUrl = origin.replace("payments", "apps");
    return `${appsUrl}${enrollPath}`;
  }

  return enrollPath;
};

export const convenienceFee = 4.95;

export const loanInformationHeader = {
  header: "Make Your Loan Payment",
  description:
    "Take care of your loan payment in three easy steps. We just need some information to get started.",
};

export const loanPaymentHeader = {
  header: "Enter Payment Information",
  description:
    "Confirm that the loan details are correct. Then enter your debit card information or routing and account number and the amount you’d like to apply to your loan.",
};

export const loanReviewHeader = {
  header: "Almost Done!",
  description: "Review and submit your payment.",
};

export const payoffCompleteHeader = {
  header: "Payoff Confirmation",
  description:
    "After your payment posts, your loan will be paid off. Congratulations! You’ve worked hard to reach this major milestone.",
};

export const paymentCompleteHeader = {
  header: "Thank You for Your Payment",
  description: "All set! Thanks for making your payment. We’ll email a receipt to you soon.",
};

export const errorMessages = {
  fetchingTokenFailed: "Could not initialize app",
  loanNotFound: "The information provided doesn’t match our records",
  verifyingPaymentDetailsFailed: "Your payment could not be made at this time.",
  submittingPaymentFailed: "Your payment could not be made at this time.",
  requestFailed: "Your request could not be completed at this time.",
};

export const debitAndCreditDisclosure = `By checking this box and clicking &quot;SUBMIT PAYMENT&quot;,
                                I authorize Lake Trust Credit Union to initiate, and my financial
                                institution to honor, a ONE-TIME electronic payment in the amount
                                specified above from the bank account associated with my debit/credit
                                card noted above and that I am legally authorized to make payments
                                using said debit/credit card. I also confirm that the information I
                                provided is accurate and complete, I am 18 years or older, and
                                I have read and agree to <a target='_blank' href='${getWebsiteUrl()}/Privacy'>Lake Trust's Privacy Policy</a>.`;

export const achSecondDisclosure = `By checking this box and clicking 'SUBMIT PAYMENT,' I authorize Lake Trust Credit Union to conduct the ACH transfer from the account indicated above. I acknowledge and agree that if the payment is returned for any reason, the requested payment will be reversed on my Lake Trust loan and I will be responsible for making my loan payment separately. I also confirm that the information I provided is accurate and complete, I am 18 years or older, I am legally authorized to make payments from the account above, and I have read and agree to <a href='${getWebsiteDocumentUrl()}/LakeTrustWebsite/media/Assets/Personal-Terms-Conditions.pdf' target='_blank'>Lake Trust's Account Terms and Conditions</a> and <a target='_blank' href='${getWebsiteUrl()}/Privacy'>Lake Trust's Privacy Policy</a>.`;

export const termsAndConditionsLink = () => {
  return `${getWebsiteDocumentUrl()}/LakeTrustWebsite/media/Assets/Personal-Terms-Conditions.pdf`;
};



// WEBPACK FOOTER //
// ./src/utils/content.js